import API from "@aws-amplify/api";
import {
  createAgentFunction,
  deleteAgentFunction,
  updateAgentFunction,
} from "../../graphql/mutations";
import { functionsByWorkspace, getAgentFunction } from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createAgentFunction_ = async (object, userId = null) => {
  const input = { ...object };
  if (userId) {
    input.createdBy = userId;
    input.updatedBy = userId;
  }
  return makeGraphQLRequest({
    query: createAgentFunction,
    variables: { input },
  });
};
const getAgentFunction_ = async (id) => {
  return makeGraphQLRequest({
    query: getAgentFunction,
    variables: { id },
  });
};
const updateAgentFunction_ = async (id, args, userId = null) => {
  const original = await getAgentFunction_(id);
  let _properties = {};
  args.forEach((item) => {
    _properties[item.property] = item.value;
  });
  const input = {
    id,
    _version: original?.data?.getAgentFunction?._version,
    ..._properties,
  };
  if (userId) {
    input.updatedBy = userId;
  }
  return makeGraphQLRequest({
    query: updateAgentFunction,
    variables: { input },
  });
};

const deleteAgentFunction_ = async (id) => {
  const original = await getAgentFunction_(id);
  return makeGraphQLRequest({
    query: deleteAgentFunction,
    variables: {
      input: {
        id,
        _version: original?.data?.getAgentFunction?._version,
      },
    },
  });
};

const getAgentFunctions_ = async (workspaceID, nextToken) => {
  return makeGraphQLRequest({
    query: functionsByWorkspace,
    variables: {
      workspaceID,
      nextToken,
    },
  });
};

export default {
  createAgentFunction: createAgentFunction_,
  updateAgentFunction: updateAgentFunction_,
  deleteAgentFunction: deleteAgentFunction_,
  getAgentFunction: getAgentFunction_,
  getAgentFunctions: getAgentFunctions_,
};
